import { render, staticRenderFns } from "./VasionFolderSelect.vue?vue&type=template&id=7facd120&scoped=true&"
import script from "./VasionFolderSelect.vue?vue&type=script&lang=js&"
export * from "./VasionFolderSelect.vue?vue&type=script&lang=js&"
import style0 from "./VasionFolderSelect.vue?vue&type=style&index=0&id=7facd120&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7facd120",
  null
  
)

export default component.exports